import api from "./api";

// -------------------- LENGTHS --------------------
export const fetchLengths = async () => {
  const res = await api.get("/core/lengths/");
  return res.data;
};

export const createLength = async (length) => {
  const res = await api.post("/core/lengths/", length);
  return res.data;
};

export const updateLength = async (id, length) => {
  const res = await api.put(`/core/lengths/${id}/`, length);
  return res.data;
};

export const deleteLength = async (id) => {
  const res = await api.delete(`/core/lengths/${id}/`);
  return res.data;
};
